import { render } from "./EmailSettingsAccountModeTransfer.vue?vue&type=template&id=31330556&scoped=true"
import script from "./EmailSettingsAccountModeTransfer.vue?vue&type=script&lang=js"
export * from "./EmailSettingsAccountModeTransfer.vue?vue&type=script&lang=js"

import "./EmailSettingsAccountModeTransfer.vue?vue&type=style&index=0&id=31330556&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31330556"]])

export default __exports__